import {
  INDENT_CONTENT_COMMAND,
  LexicalEditor,
  OUTDENT_CONTENT_COMMAND,
} from "lexical";
import React from "react";
import { IndentIcon, OutdentIcon } from "../../../../assets/icons/SvgIcons";
import { toolTipConstants } from "../../LexicalEditor.types";

const Adjust = ({
  editor,
  isRTL,
}: {
  editor: LexicalEditor;
  isRTL: boolean;
}) => {
  return (
    <>
      <button
        type="button"
        onClick={() => {
          editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined);
        }}
        className="lexical-toolbarItem"
        aria-label="Outdent"
        title={toolTipConstants.decreaseIndent}
      >
        <OutdentIcon />
      </button>
      <button
        type="button"
        onClick={() => {
          editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
        }}
        className="lexical-toolbarItem"
        aria-label="Indent"
        title={toolTipConstants.increaseIndent}
      >
        <IndentIcon />
      </button>
    </>
  );
};

export default Adjust;
